import { rawCommonPdfStyles } from 'common/components/PdfViewModal/common.stylesheet';
import React from 'react';

import { AccountingEntryInvoice } from 'ap/signing/accountingEntry/view/__generated__/AccountingEntryInvoice';
import { InvoiceTransactionTypes } from 'common/components/Modules/TransactionEdit/graphql/__generated__/InvoiceTransactionTypes';
import { usePdfRenderer } from 'common/hooks/usePdfRenderer';
import { SignatureSection } from './SignatureSection';
import { Table } from './Table';
import { Transaction } from './Transaction';

export interface PdfDocumentProps {
  invoiceData?: AccountingEntryInvoice;
  transactionTypeData?: InvoiceTransactionTypes;
}

export const PdfDocument: React.FC<PdfDocumentProps> = ({
  invoiceData,
  transactionTypeData,
}) => {
  
  const { Document, Page, PDFViewer, View, getStyleSheet } = usePdfRenderer();
   const commonPdfStyles = getStyleSheet(() => rawCommonPdfStyles);
  if (!PDFViewer || !Document || !Page || !View || !Image || !commonPdfStyles)
    return null;

  return (
    <PDFViewer style={{ flex: 1 }}>
      <Document>
        <Page size="A4" style={commonPdfStyles.page}>
          <View style={{ flex: 1 }}>
            <Transaction invoiceData={invoiceData} />
            <Table
              data={invoiceData!}
              transactionTypeData={transactionTypeData}
            />
            {invoiceData?.invoice?.approvalHistorySignaturesByEntityId.nodes &&
              invoiceData?.invoice?.approvalHistorySignaturesByEntityId.nodes
                .length > 0 && (
                <View style={{ top: 20, left: 10 }}>
                  <SignatureSection invoiceData={invoiceData} />
                </View>
              )}
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
